import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'di-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.scss'],
})
export class SignatureComponent implements AfterViewInit {
  @ViewChild('canvas', { static: true }) canvasEl: ElementRef<HTMLCanvasElement>;
  private signaturePad: SignaturePad;
  private pendingImage: string | null = null;
  private isInitialized = false;

  @Input() set image(dataUrl: string | null) {
    if (dataUrl) {
      if (this.isInitialized) {
        this.loadImage(dataUrl);
      } else {
        this.pendingImage = dataUrl;
      }
    }
  }

  @Input() readOnly: boolean = false;
  @Input() options?: { penColor?: string; backgroundColor?: string };

  public ngAfterViewInit(): void {
		const canvas = this.canvasEl.nativeElement;
		this.signaturePad = new SignaturePad(canvas, { ...this.options });
		
		window.addEventListener('resize', this.resizeCanvas.bind(this));
		this.readOnly ? this.signaturePad.off() : this.signaturePad.on();
	
		// Attend la prochaine frame pour forcer le resize
		setTimeout(() => {
			this.resizeCanvas();
			this.signaturePad.clear();
	
			this.isInitialized = true;
			if (this.pendingImage) {
				this.loadImage(this.pendingImage);
				this.pendingImage = null;
			}
		}, 50);
	}

  private resizeCanvas(): void {
    const canvas = this.canvasEl.nativeElement;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext('2d')?.scale(ratio, ratio);
    console.log('Canvas resized to:', canvas.width, canvas.height);
  }

  clear(): void {
    this.signaturePad.clear();
  }

  save(): string {
    return this.signaturePad.isEmpty() ? '' : this.signaturePad.toDataURL('image/png');
  }

  private loadImage(dataUrl: string): void {
    const image = new Image();
    image.onload = () => {
      this.signaturePad.fromDataURL(dataUrl);
    };
    image.onerror = () => {
      console.error('Erreur chargement image', dataUrl?.substring(0, 100));
    };
    image.src = dataUrl;
  }
}
